<template>
    <div>
        <keep-alive include="layout" >
            <router-view  ></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'app',
        mounted() {
            if (!$('html').hasClass('ismobile')) {
                if ($('.page-loader')[0]) {
                    setTimeout(function () {
                        $('.page-loader').fadeOut();
                    }, 100);
                }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// App.vue?3a9894fe